"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NonEditableRows = void 0;
var React = __importStar(require("react"));
var lodash_1 = __importDefault(require("lodash"));
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../");
var SharedComponents_1 = require("./SharedComponents");
var SharedFunctions_1 = require("./SharedFunctions");
var LockIcon = (0, styled_components_1.default)('span').attrs({
    className: 'tws-editable-lock-icon',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: absolute;\n\tcolor: white;\n\tbackground-color: #999999;\n\tfont-size: 6pt;\n\twidth: 16px;\n\theight: 16px;\n\tborder-radius: 50%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\ttop: 10px;\n\tright: 5px;\n"], ["\n\tposition: absolute;\n\tcolor: white;\n\tbackground-color: #999999;\n\tfont-size: 6pt;\n\twidth: 16px;\n\theight: 16px;\n\tborder-radius: 50%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\ttop: 10px;\n\tright: 5px;\n"])));
LockIcon.displayName = 'LockIcon';
var NonEditableRows = /** @class */ (function (_super) {
    __extends(NonEditableRows, _super);
    function NonEditableRows(props) {
        return _super.call(this, props) || this;
    }
    NonEditableRows.prototype.shouldComponentUpdate = function (nextProps) {
        return (nextProps.editMode !== this.props.editMode ||
            nextProps.deletedUniqueIds !== this.props.deletedUniqueIds ||
            nextProps.duplicatedExistingUniqueIds !== this.props.duplicatedExistingUniqueIds ||
            !lodash_1.default.isEqual(nextProps.data, this.props.data));
    };
    NonEditableRows.prototype.render = function () {
        var _a = this.props, columns = _a.columns, data = _a.data, defaultCode = _a.defaultCode, deleteColumn = _a.deleteColumn, deletedUniqueIds = _a.deletedUniqueIds, duplicatedExistingUniqueIds = _a.duplicatedExistingUniqueIds, editMode = _a.editMode, isDefault = _a.isDefault, onFormatText = _a.onFormatText, deleteIconClick = _a.deleteIconClick;
        return (React.createElement(React.Fragment, null, data &&
            data.map(function (record, index) {
                var className = record.isNew ? '' : 'tws-editable-row-existing';
                if (duplicatedExistingUniqueIds.indexOf(record.uniqueId) > -1) {
                    className += ' duplicated';
                }
                if (index + 1 === data.length) {
                    className += ' last-row';
                }
                var deleted = deletedUniqueIds.indexOf(record.uniqueId) > -1;
                var duplicated = duplicatedExistingUniqueIds.indexOf(record.uniqueId) > -1;
                var recordIsDefault = (0, SharedFunctions_1.IsDefault)(record, columns, isDefault, defaultCode);
                return (React.createElement(SharedComponents_1.TableRow, { className: className, key: "editable-row-".concat(record.uniqueId), record: record, editMode: editMode, deleted: deleted, duplicated: duplicated },
                    columns.map(function (column) {
                        return (React.createElement(SharedComponents_1.TableColumn, { key: "editable-column-".concat(record.uniqueId), editMode: false, editable: column.editable, deleted: deleted, isDefault: recordIsDefault },
                            onFormatText(column, record),
                            column.yesIndicator && recordIsDefault && (React.createElement(LockIcon, null,
                                React.createElement(__1.Icon, { name: 'security' })))));
                    }),
                    deleteColumn && (React.createElement(SharedComponents_1.TableColumn, { editMode: editMode, deleted: deleted },
                        React.createElement(SharedComponents_1.DeleteIconContainer, { editMode: editMode, deleted: deleted, onClick: function () { return deleteIconClick(record, deleted); } }, !recordIsDefault && (editMode && deleted ? React.createElement(SharedComponents_1.UndoIcon, { name: 'undo' }) : React.createElement(__1.Icon, { name: 'delete' })))))));
            })));
    };
    // Default props
    NonEditableRows.defaultProps = {
        duplicatedExistingUniqueIds: [],
        deletedUniqueIds: [],
        getError: function () { return ({}); },
        onSelect: function () {
            return;
        },
    };
    return NonEditableRows;
}(React.Component));
exports.NonEditableRows = NonEditableRows;
var templateObject_1;
